import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { ClockFilledIcon } from '../../components';
const ProductDuration = ({ className, label }) => (_jsxs("span", { className: classNames('d-inline-flex align-items-center', className), children: [_jsx(ClockFilledIcon, { ariaHidden: true, className: "mr-0-5x" }), " ", label] }));
export { ProductDuration };
